import moment from "moment";
import { decodedText } from "../../../../helpers/utils";
import HoverMenu from "./HoverMenu";
import { useSelector } from "react-redux";
import { messageIdsMatch } from "./pinnedMessageUtils";

const numberOfDays = (createdAt) => {
    const createdAtDate = new Date(createdAt);
    const currentDate = new Date();
    createdAtDate.setHours(0, 0, 0, 0);
    currentDate.setHours(0, 0, 0, 0);
    const differenceInMilliseconds = currentDate.getTime() - createdAtDate.getTime();
    const differenceInDays = Math.floor(differenceInMilliseconds / (1000 * 60 * 60 * 24));
    const remainingDays = 7 - differenceInDays;
    return remainingDays >= 0 ? remainingDays : 0;
};

const Message = ({ msg, pinnedMessage }) => {
    const { user: currentUser } = useSelector((state) => state.auth);
    
    if (msg?.type !== 'message') return null;

    const { attributes } = msg;
    const messageUser = attributes?.user;
    
    // Check if the message is from the current logged-in dashboard user
    const isCurrentUser = currentUser?.id === messageUser?.id;
    
    // Check if the message is from a dashboard user (admin, root, or dj)
    // Dashboard users can be identified by having roles or by matching current user
    const isDashboardUser = isCurrentUser || 
        (messageUser?.roles && messageUser.roles.some(role => 
            ['root', 'admin', 'dj'].includes(role)
        ));
    
    let explodedName = messageUser?.name?.split(' ') || [];
    let initials = `${explodedName[0]?.charAt(0) ?? ''}${explodedName[1]?.charAt(0) ?? ''}`.toUpperCase();

    // For dashboard users, show profile photo or station logo as fallback
    if (isDashboardUser) {
        // For current user, use their profile photo from state
        if (isCurrentUser && currentUser?.attributes?.avatar) {
            initials = <img className="avatar" src={currentUser.attributes.avatar} alt="Profile Photo" />;
        } else if (messageUser?.avatar) {
            // For other dashboard users, use their profile photo from message
            initials = <img className="avatar" src={messageUser.avatar} alt="Profile Photo" />;
        } else if (isCurrentUser && currentUser?.attributes?.stationLogo) {
            // Fallback to station logo for current user
            initials = <img className="avatar" src={currentUser.attributes.stationLogo} alt="Station Logo" />;
        } else if (messageUser?.stationLogo) {
            // Fallback to station logo for other dashboard users
            initials = <img className="avatar" src={messageUser.stationLogo} alt="Station Logo" />;
        }
    } else if (messageUser?.avatar) {
        // For app users, show avatar as before
        initials = <img className="avatar" src={messageUser.avatar} alt="Avatar" />;
    }

    const createdAt = attributes?.createdAt;
    const remainingDays = numberOfDays(createdAt);
    return (
        <div className={`message-row shadow-sm ${messageIdsMatch(pinnedMessage?.id, msg?.id) ? "highlight-pinned" : ""}`}>
            <HoverMenu msg={msg} />
            <div className="namedLogo">
                {initials}
            </div>

            {(!attributes?.media || attributes?.media === "") ? (
                <div className="message-text">
                    <span className="username">{attributes?.user?.name}</span>
                    <span className="message">{decodedText(attributes?.sanitizedText)}</span>
                </div>
            ) : (
                <>
                <div className="message-text">
                <span className="username">{attributes?.user?.name}</span>
                        <audio controls src={attributes.media} style={{ width: '100%' }}>
                            Your browser does not support the audio element.
                        </audio>
                        <span className="auto-delete-info text-danger mt-1 f-10">
                            {remainingDays > 0 ? (
                                <span>{remainingDays} Day{remainingDays > 1 ? 's' : ''} until expiration.</span>
                            ) : (
                                <span>Message expired.</span>
                            )}
                        </span>
                    </div>

                </>
            )}

            <div className="d-flex">
                <span className="date">{moment(createdAt).fromNow()}</span>
            </div>
        </div>
    );
};

export default Message;
